/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const review = $root.review = (() => {

    /**
     * Namespace review.
     * @exports review
     * @namespace
     */
    const review = {};

    review.ReviewEntityAttribute = (function() {

        /**
         * Properties of a ReviewEntityAttribute.
         * @memberof review
         * @interface IReviewEntityAttribute
         * @property {string|null} [name] ReviewEntityAttribute name
         * @property {string|null} [description] ReviewEntityAttribute description
         * @property {string|null} [value] ReviewEntityAttribute value
         */

        /**
         * Constructs a new ReviewEntityAttribute.
         * @memberof review
         * @classdesc Represents a ReviewEntityAttribute.
         * @implements IReviewEntityAttribute
         * @constructor
         * @param {review.IReviewEntityAttribute=} [properties] Properties to set
         */
        function ReviewEntityAttribute(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ReviewEntityAttribute name.
         * @member {string} name
         * @memberof review.ReviewEntityAttribute
         * @instance
         */
        ReviewEntityAttribute.prototype.name = "";

        /**
         * ReviewEntityAttribute description.
         * @member {string} description
         * @memberof review.ReviewEntityAttribute
         * @instance
         */
        ReviewEntityAttribute.prototype.description = "";

        /**
         * ReviewEntityAttribute value.
         * @member {string} value
         * @memberof review.ReviewEntityAttribute
         * @instance
         */
        ReviewEntityAttribute.prototype.value = "";

        /**
         * Creates a new ReviewEntityAttribute instance using the specified properties.
         * @function create
         * @memberof review.ReviewEntityAttribute
         * @static
         * @param {review.IReviewEntityAttribute=} [properties] Properties to set
         * @returns {review.ReviewEntityAttribute} ReviewEntityAttribute instance
         */
        ReviewEntityAttribute.create = function create(properties) {
            return new ReviewEntityAttribute(properties);
        };

        /**
         * Encodes the specified ReviewEntityAttribute message. Does not implicitly {@link review.ReviewEntityAttribute.verify|verify} messages.
         * @function encode
         * @memberof review.ReviewEntityAttribute
         * @static
         * @param {review.IReviewEntityAttribute} message ReviewEntityAttribute message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReviewEntityAttribute.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
            if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.description);
            if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.value);
            return writer;
        };

        /**
         * Encodes the specified ReviewEntityAttribute message, length delimited. Does not implicitly {@link review.ReviewEntityAttribute.verify|verify} messages.
         * @function encodeDelimited
         * @memberof review.ReviewEntityAttribute
         * @static
         * @param {review.IReviewEntityAttribute} message ReviewEntityAttribute message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReviewEntityAttribute.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ReviewEntityAttribute message from the specified reader or buffer.
         * @function decode
         * @memberof review.ReviewEntityAttribute
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {review.ReviewEntityAttribute} ReviewEntityAttribute
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReviewEntityAttribute.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.review.ReviewEntityAttribute();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.name = reader.string();
                        break;
                    }
                case 2: {
                        message.description = reader.string();
                        break;
                    }
                case 3: {
                        message.value = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ReviewEntityAttribute message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof review.ReviewEntityAttribute
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {review.ReviewEntityAttribute} ReviewEntityAttribute
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReviewEntityAttribute.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ReviewEntityAttribute message.
         * @function verify
         * @memberof review.ReviewEntityAttribute
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ReviewEntityAttribute.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.description != null && message.hasOwnProperty("description"))
                if (!$util.isString(message.description))
                    return "description: string expected";
            if (message.value != null && message.hasOwnProperty("value"))
                if (!$util.isString(message.value))
                    return "value: string expected";
            return null;
        };

        /**
         * Creates a ReviewEntityAttribute message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof review.ReviewEntityAttribute
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {review.ReviewEntityAttribute} ReviewEntityAttribute
         */
        ReviewEntityAttribute.fromObject = function fromObject(object) {
            if (object instanceof $root.review.ReviewEntityAttribute)
                return object;
            let message = new $root.review.ReviewEntityAttribute();
            if (object.name != null)
                message.name = String(object.name);
            if (object.description != null)
                message.description = String(object.description);
            if (object.value != null)
                message.value = String(object.value);
            return message;
        };

        /**
         * Creates a plain object from a ReviewEntityAttribute message. Also converts values to other types if specified.
         * @function toObject
         * @memberof review.ReviewEntityAttribute
         * @static
         * @param {review.ReviewEntityAttribute} message ReviewEntityAttribute
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ReviewEntityAttribute.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.name = "";
                object.description = "";
                object.value = "";
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.description != null && message.hasOwnProperty("description"))
                object.description = message.description;
            if (message.value != null && message.hasOwnProperty("value"))
                object.value = message.value;
            return object;
        };

        /**
         * Converts this ReviewEntityAttribute to JSON.
         * @function toJSON
         * @memberof review.ReviewEntityAttribute
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ReviewEntityAttribute.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ReviewEntityAttribute
         * @function getTypeUrl
         * @memberof review.ReviewEntityAttribute
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ReviewEntityAttribute.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/review.ReviewEntityAttribute";
        };

        return ReviewEntityAttribute;
    })();

    review.ReviewEntity = (function() {

        /**
         * Properties of a ReviewEntity.
         * @memberof review
         * @interface IReviewEntity
         * @property {number|null} [id] ReviewEntity id
         * @property {string|null} [name] ReviewEntity name
         * @property {string|null} [description] ReviewEntity description
         * @property {string|null} [orgEntityCode] ReviewEntity orgEntityCode
         * @property {string|null} [reviewEntityType] ReviewEntity reviewEntityType
         * @property {Array.<number>|null} [reviewerIds] ReviewEntity reviewerIds
         * @property {Array.<number>|null} [revieweeIds] ReviewEntity revieweeIds
         * @property {Array.<string>|null} [applicableReviewFrequencies] ReviewEntity applicableReviewFrequencies
         * @property {Array.<number>|null} [parentIds] ReviewEntity parentIds
         * @property {Array.<string>|null} [reviewerNames] ReviewEntity reviewerNames
         * @property {Array.<string>|null} [revieweeNames] ReviewEntity revieweeNames
         * @property {string|null} [reviewEntityTypeName] ReviewEntity reviewEntityTypeName
         * @property {Array.<review.IReviewEntityAttribute>|null} [attributes] ReviewEntity attributes
         * @property {number|null} [createdBy] ReviewEntity createdBy
         * @property {number|null} [updatedBy] ReviewEntity updatedBy
         * @property {string|null} [createdAt] ReviewEntity createdAt
         * @property {string|null} [updatedAt] ReviewEntity updatedAt
         */

        /**
         * Constructs a new ReviewEntity.
         * @memberof review
         * @classdesc Represents a ReviewEntity.
         * @implements IReviewEntity
         * @constructor
         * @param {review.IReviewEntity=} [properties] Properties to set
         */
        function ReviewEntity(properties) {
            this.reviewerIds = [];
            this.revieweeIds = [];
            this.applicableReviewFrequencies = [];
            this.parentIds = [];
            this.reviewerNames = [];
            this.revieweeNames = [];
            this.attributes = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ReviewEntity id.
         * @member {number} id
         * @memberof review.ReviewEntity
         * @instance
         */
        ReviewEntity.prototype.id = 0;

        /**
         * ReviewEntity name.
         * @member {string} name
         * @memberof review.ReviewEntity
         * @instance
         */
        ReviewEntity.prototype.name = "";

        /**
         * ReviewEntity description.
         * @member {string} description
         * @memberof review.ReviewEntity
         * @instance
         */
        ReviewEntity.prototype.description = "";

        /**
         * ReviewEntity orgEntityCode.
         * @member {string} orgEntityCode
         * @memberof review.ReviewEntity
         * @instance
         */
        ReviewEntity.prototype.orgEntityCode = "";

        /**
         * ReviewEntity reviewEntityType.
         * @member {string} reviewEntityType
         * @memberof review.ReviewEntity
         * @instance
         */
        ReviewEntity.prototype.reviewEntityType = "";

        /**
         * ReviewEntity reviewerIds.
         * @member {Array.<number>} reviewerIds
         * @memberof review.ReviewEntity
         * @instance
         */
        ReviewEntity.prototype.reviewerIds = $util.emptyArray;

        /**
         * ReviewEntity revieweeIds.
         * @member {Array.<number>} revieweeIds
         * @memberof review.ReviewEntity
         * @instance
         */
        ReviewEntity.prototype.revieweeIds = $util.emptyArray;

        /**
         * ReviewEntity applicableReviewFrequencies.
         * @member {Array.<string>} applicableReviewFrequencies
         * @memberof review.ReviewEntity
         * @instance
         */
        ReviewEntity.prototype.applicableReviewFrequencies = $util.emptyArray;

        /**
         * ReviewEntity parentIds.
         * @member {Array.<number>} parentIds
         * @memberof review.ReviewEntity
         * @instance
         */
        ReviewEntity.prototype.parentIds = $util.emptyArray;

        /**
         * ReviewEntity reviewerNames.
         * @member {Array.<string>} reviewerNames
         * @memberof review.ReviewEntity
         * @instance
         */
        ReviewEntity.prototype.reviewerNames = $util.emptyArray;

        /**
         * ReviewEntity revieweeNames.
         * @member {Array.<string>} revieweeNames
         * @memberof review.ReviewEntity
         * @instance
         */
        ReviewEntity.prototype.revieweeNames = $util.emptyArray;

        /**
         * ReviewEntity reviewEntityTypeName.
         * @member {string} reviewEntityTypeName
         * @memberof review.ReviewEntity
         * @instance
         */
        ReviewEntity.prototype.reviewEntityTypeName = "";

        /**
         * ReviewEntity attributes.
         * @member {Array.<review.IReviewEntityAttribute>} attributes
         * @memberof review.ReviewEntity
         * @instance
         */
        ReviewEntity.prototype.attributes = $util.emptyArray;

        /**
         * ReviewEntity createdBy.
         * @member {number} createdBy
         * @memberof review.ReviewEntity
         * @instance
         */
        ReviewEntity.prototype.createdBy = 0;

        /**
         * ReviewEntity updatedBy.
         * @member {number} updatedBy
         * @memberof review.ReviewEntity
         * @instance
         */
        ReviewEntity.prototype.updatedBy = 0;

        /**
         * ReviewEntity createdAt.
         * @member {string} createdAt
         * @memberof review.ReviewEntity
         * @instance
         */
        ReviewEntity.prototype.createdAt = "";

        /**
         * ReviewEntity updatedAt.
         * @member {string} updatedAt
         * @memberof review.ReviewEntity
         * @instance
         */
        ReviewEntity.prototype.updatedAt = "";

        /**
         * Creates a new ReviewEntity instance using the specified properties.
         * @function create
         * @memberof review.ReviewEntity
         * @static
         * @param {review.IReviewEntity=} [properties] Properties to set
         * @returns {review.ReviewEntity} ReviewEntity instance
         */
        ReviewEntity.create = function create(properties) {
            return new ReviewEntity(properties);
        };

        /**
         * Encodes the specified ReviewEntity message. Does not implicitly {@link review.ReviewEntity.verify|verify} messages.
         * @function encode
         * @memberof review.ReviewEntity
         * @static
         * @param {review.IReviewEntity} message ReviewEntity message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReviewEntity.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.id);
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
            if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.description);
            if (message.orgEntityCode != null && Object.hasOwnProperty.call(message, "orgEntityCode"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.orgEntityCode);
            if (message.reviewEntityType != null && Object.hasOwnProperty.call(message, "reviewEntityType"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.reviewEntityType);
            if (message.reviewerIds != null && message.reviewerIds.length) {
                writer.uint32(/* id 6, wireType 2 =*/50).fork();
                for (let i = 0; i < message.reviewerIds.length; ++i)
                    writer.int32(message.reviewerIds[i]);
                writer.ldelim();
            }
            if (message.revieweeIds != null && message.revieweeIds.length) {
                writer.uint32(/* id 7, wireType 2 =*/58).fork();
                for (let i = 0; i < message.revieweeIds.length; ++i)
                    writer.int32(message.revieweeIds[i]);
                writer.ldelim();
            }
            if (message.applicableReviewFrequencies != null && message.applicableReviewFrequencies.length)
                for (let i = 0; i < message.applicableReviewFrequencies.length; ++i)
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.applicableReviewFrequencies[i]);
            if (message.parentIds != null && message.parentIds.length) {
                writer.uint32(/* id 9, wireType 2 =*/74).fork();
                for (let i = 0; i < message.parentIds.length; ++i)
                    writer.int32(message.parentIds[i]);
                writer.ldelim();
            }
            if (message.reviewerNames != null && message.reviewerNames.length)
                for (let i = 0; i < message.reviewerNames.length; ++i)
                    writer.uint32(/* id 10, wireType 2 =*/82).string(message.reviewerNames[i]);
            if (message.revieweeNames != null && message.revieweeNames.length)
                for (let i = 0; i < message.revieweeNames.length; ++i)
                    writer.uint32(/* id 11, wireType 2 =*/90).string(message.revieweeNames[i]);
            if (message.reviewEntityTypeName != null && Object.hasOwnProperty.call(message, "reviewEntityTypeName"))
                writer.uint32(/* id 12, wireType 2 =*/98).string(message.reviewEntityTypeName);
            if (message.attributes != null && message.attributes.length)
                for (let i = 0; i < message.attributes.length; ++i)
                    $root.review.ReviewEntityAttribute.encode(message.attributes[i], writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
            if (message.createdBy != null && Object.hasOwnProperty.call(message, "createdBy"))
                writer.uint32(/* id 14, wireType 0 =*/112).int32(message.createdBy);
            if (message.updatedBy != null && Object.hasOwnProperty.call(message, "updatedBy"))
                writer.uint32(/* id 15, wireType 0 =*/120).int32(message.updatedBy);
            if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                writer.uint32(/* id 16, wireType 2 =*/130).string(message.createdAt);
            if (message.updatedAt != null && Object.hasOwnProperty.call(message, "updatedAt"))
                writer.uint32(/* id 17, wireType 2 =*/138).string(message.updatedAt);
            return writer;
        };

        /**
         * Encodes the specified ReviewEntity message, length delimited. Does not implicitly {@link review.ReviewEntity.verify|verify} messages.
         * @function encodeDelimited
         * @memberof review.ReviewEntity
         * @static
         * @param {review.IReviewEntity} message ReviewEntity message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReviewEntity.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ReviewEntity message from the specified reader or buffer.
         * @function decode
         * @memberof review.ReviewEntity
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {review.ReviewEntity} ReviewEntity
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReviewEntity.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.review.ReviewEntity();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.id = reader.int32();
                        break;
                    }
                case 2: {
                        message.name = reader.string();
                        break;
                    }
                case 3: {
                        message.description = reader.string();
                        break;
                    }
                case 4: {
                        message.orgEntityCode = reader.string();
                        break;
                    }
                case 5: {
                        message.reviewEntityType = reader.string();
                        break;
                    }
                case 6: {
                        if (!(message.reviewerIds && message.reviewerIds.length))
                            message.reviewerIds = [];
                        if ((tag & 7) === 2) {
                            let end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.reviewerIds.push(reader.int32());
                        } else
                            message.reviewerIds.push(reader.int32());
                        break;
                    }
                case 7: {
                        if (!(message.revieweeIds && message.revieweeIds.length))
                            message.revieweeIds = [];
                        if ((tag & 7) === 2) {
                            let end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.revieweeIds.push(reader.int32());
                        } else
                            message.revieweeIds.push(reader.int32());
                        break;
                    }
                case 8: {
                        if (!(message.applicableReviewFrequencies && message.applicableReviewFrequencies.length))
                            message.applicableReviewFrequencies = [];
                        message.applicableReviewFrequencies.push(reader.string());
                        break;
                    }
                case 9: {
                        if (!(message.parentIds && message.parentIds.length))
                            message.parentIds = [];
                        if ((tag & 7) === 2) {
                            let end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.parentIds.push(reader.int32());
                        } else
                            message.parentIds.push(reader.int32());
                        break;
                    }
                case 10: {
                        if (!(message.reviewerNames && message.reviewerNames.length))
                            message.reviewerNames = [];
                        message.reviewerNames.push(reader.string());
                        break;
                    }
                case 11: {
                        if (!(message.revieweeNames && message.revieweeNames.length))
                            message.revieweeNames = [];
                        message.revieweeNames.push(reader.string());
                        break;
                    }
                case 12: {
                        message.reviewEntityTypeName = reader.string();
                        break;
                    }
                case 13: {
                        if (!(message.attributes && message.attributes.length))
                            message.attributes = [];
                        message.attributes.push($root.review.ReviewEntityAttribute.decode(reader, reader.uint32()));
                        break;
                    }
                case 14: {
                        message.createdBy = reader.int32();
                        break;
                    }
                case 15: {
                        message.updatedBy = reader.int32();
                        break;
                    }
                case 16: {
                        message.createdAt = reader.string();
                        break;
                    }
                case 17: {
                        message.updatedAt = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ReviewEntity message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof review.ReviewEntity
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {review.ReviewEntity} ReviewEntity
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReviewEntity.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ReviewEntity message.
         * @function verify
         * @memberof review.ReviewEntity
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ReviewEntity.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isInteger(message.id))
                    return "id: integer expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.description != null && message.hasOwnProperty("description"))
                if (!$util.isString(message.description))
                    return "description: string expected";
            if (message.orgEntityCode != null && message.hasOwnProperty("orgEntityCode"))
                if (!$util.isString(message.orgEntityCode))
                    return "orgEntityCode: string expected";
            if (message.reviewEntityType != null && message.hasOwnProperty("reviewEntityType"))
                if (!$util.isString(message.reviewEntityType))
                    return "reviewEntityType: string expected";
            if (message.reviewerIds != null && message.hasOwnProperty("reviewerIds")) {
                if (!Array.isArray(message.reviewerIds))
                    return "reviewerIds: array expected";
                for (let i = 0; i < message.reviewerIds.length; ++i)
                    if (!$util.isInteger(message.reviewerIds[i]))
                        return "reviewerIds: integer[] expected";
            }
            if (message.revieweeIds != null && message.hasOwnProperty("revieweeIds")) {
                if (!Array.isArray(message.revieweeIds))
                    return "revieweeIds: array expected";
                for (let i = 0; i < message.revieweeIds.length; ++i)
                    if (!$util.isInteger(message.revieweeIds[i]))
                        return "revieweeIds: integer[] expected";
            }
            if (message.applicableReviewFrequencies != null && message.hasOwnProperty("applicableReviewFrequencies")) {
                if (!Array.isArray(message.applicableReviewFrequencies))
                    return "applicableReviewFrequencies: array expected";
                for (let i = 0; i < message.applicableReviewFrequencies.length; ++i)
                    if (!$util.isString(message.applicableReviewFrequencies[i]))
                        return "applicableReviewFrequencies: string[] expected";
            }
            if (message.parentIds != null && message.hasOwnProperty("parentIds")) {
                if (!Array.isArray(message.parentIds))
                    return "parentIds: array expected";
                for (let i = 0; i < message.parentIds.length; ++i)
                    if (!$util.isInteger(message.parentIds[i]))
                        return "parentIds: integer[] expected";
            }
            if (message.reviewerNames != null && message.hasOwnProperty("reviewerNames")) {
                if (!Array.isArray(message.reviewerNames))
                    return "reviewerNames: array expected";
                for (let i = 0; i < message.reviewerNames.length; ++i)
                    if (!$util.isString(message.reviewerNames[i]))
                        return "reviewerNames: string[] expected";
            }
            if (message.revieweeNames != null && message.hasOwnProperty("revieweeNames")) {
                if (!Array.isArray(message.revieweeNames))
                    return "revieweeNames: array expected";
                for (let i = 0; i < message.revieweeNames.length; ++i)
                    if (!$util.isString(message.revieweeNames[i]))
                        return "revieweeNames: string[] expected";
            }
            if (message.reviewEntityTypeName != null && message.hasOwnProperty("reviewEntityTypeName"))
                if (!$util.isString(message.reviewEntityTypeName))
                    return "reviewEntityTypeName: string expected";
            if (message.attributes != null && message.hasOwnProperty("attributes")) {
                if (!Array.isArray(message.attributes))
                    return "attributes: array expected";
                for (let i = 0; i < message.attributes.length; ++i) {
                    let error = $root.review.ReviewEntityAttribute.verify(message.attributes[i]);
                    if (error)
                        return "attributes." + error;
                }
            }
            if (message.createdBy != null && message.hasOwnProperty("createdBy"))
                if (!$util.isInteger(message.createdBy))
                    return "createdBy: integer expected";
            if (message.updatedBy != null && message.hasOwnProperty("updatedBy"))
                if (!$util.isInteger(message.updatedBy))
                    return "updatedBy: integer expected";
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (!$util.isString(message.createdAt))
                    return "createdAt: string expected";
            if (message.updatedAt != null && message.hasOwnProperty("updatedAt"))
                if (!$util.isString(message.updatedAt))
                    return "updatedAt: string expected";
            return null;
        };

        /**
         * Creates a ReviewEntity message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof review.ReviewEntity
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {review.ReviewEntity} ReviewEntity
         */
        ReviewEntity.fromObject = function fromObject(object) {
            if (object instanceof $root.review.ReviewEntity)
                return object;
            let message = new $root.review.ReviewEntity();
            if (object.id != null)
                message.id = object.id | 0;
            if (object.name != null)
                message.name = String(object.name);
            if (object.description != null)
                message.description = String(object.description);
            if (object.orgEntityCode != null)
                message.orgEntityCode = String(object.orgEntityCode);
            if (object.reviewEntityType != null)
                message.reviewEntityType = String(object.reviewEntityType);
            if (object.reviewerIds) {
                if (!Array.isArray(object.reviewerIds))
                    throw TypeError(".review.ReviewEntity.reviewerIds: array expected");
                message.reviewerIds = [];
                for (let i = 0; i < object.reviewerIds.length; ++i)
                    message.reviewerIds[i] = object.reviewerIds[i] | 0;
            }
            if (object.revieweeIds) {
                if (!Array.isArray(object.revieweeIds))
                    throw TypeError(".review.ReviewEntity.revieweeIds: array expected");
                message.revieweeIds = [];
                for (let i = 0; i < object.revieweeIds.length; ++i)
                    message.revieweeIds[i] = object.revieweeIds[i] | 0;
            }
            if (object.applicableReviewFrequencies) {
                if (!Array.isArray(object.applicableReviewFrequencies))
                    throw TypeError(".review.ReviewEntity.applicableReviewFrequencies: array expected");
                message.applicableReviewFrequencies = [];
                for (let i = 0; i < object.applicableReviewFrequencies.length; ++i)
                    message.applicableReviewFrequencies[i] = String(object.applicableReviewFrequencies[i]);
            }
            if (object.parentIds) {
                if (!Array.isArray(object.parentIds))
                    throw TypeError(".review.ReviewEntity.parentIds: array expected");
                message.parentIds = [];
                for (let i = 0; i < object.parentIds.length; ++i)
                    message.parentIds[i] = object.parentIds[i] | 0;
            }
            if (object.reviewerNames) {
                if (!Array.isArray(object.reviewerNames))
                    throw TypeError(".review.ReviewEntity.reviewerNames: array expected");
                message.reviewerNames = [];
                for (let i = 0; i < object.reviewerNames.length; ++i)
                    message.reviewerNames[i] = String(object.reviewerNames[i]);
            }
            if (object.revieweeNames) {
                if (!Array.isArray(object.revieweeNames))
                    throw TypeError(".review.ReviewEntity.revieweeNames: array expected");
                message.revieweeNames = [];
                for (let i = 0; i < object.revieweeNames.length; ++i)
                    message.revieweeNames[i] = String(object.revieweeNames[i]);
            }
            if (object.reviewEntityTypeName != null)
                message.reviewEntityTypeName = String(object.reviewEntityTypeName);
            if (object.attributes) {
                if (!Array.isArray(object.attributes))
                    throw TypeError(".review.ReviewEntity.attributes: array expected");
                message.attributes = [];
                for (let i = 0; i < object.attributes.length; ++i) {
                    if (typeof object.attributes[i] !== "object")
                        throw TypeError(".review.ReviewEntity.attributes: object expected");
                    message.attributes[i] = $root.review.ReviewEntityAttribute.fromObject(object.attributes[i]);
                }
            }
            if (object.createdBy != null)
                message.createdBy = object.createdBy | 0;
            if (object.updatedBy != null)
                message.updatedBy = object.updatedBy | 0;
            if (object.createdAt != null)
                message.createdAt = String(object.createdAt);
            if (object.updatedAt != null)
                message.updatedAt = String(object.updatedAt);
            return message;
        };

        /**
         * Creates a plain object from a ReviewEntity message. Also converts values to other types if specified.
         * @function toObject
         * @memberof review.ReviewEntity
         * @static
         * @param {review.ReviewEntity} message ReviewEntity
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ReviewEntity.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.reviewerIds = [];
                object.revieweeIds = [];
                object.applicableReviewFrequencies = [];
                object.parentIds = [];
                object.reviewerNames = [];
                object.revieweeNames = [];
                object.attributes = [];
            }
            if (options.defaults) {
                object.id = 0;
                object.name = "";
                object.description = "";
                object.orgEntityCode = "";
                object.reviewEntityType = "";
                object.reviewEntityTypeName = "";
                object.createdBy = 0;
                object.updatedBy = 0;
                object.createdAt = "";
                object.updatedAt = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.description != null && message.hasOwnProperty("description"))
                object.description = message.description;
            if (message.orgEntityCode != null && message.hasOwnProperty("orgEntityCode"))
                object.orgEntityCode = message.orgEntityCode;
            if (message.reviewEntityType != null && message.hasOwnProperty("reviewEntityType"))
                object.reviewEntityType = message.reviewEntityType;
            if (message.reviewerIds && message.reviewerIds.length) {
                object.reviewerIds = [];
                for (let j = 0; j < message.reviewerIds.length; ++j)
                    object.reviewerIds[j] = message.reviewerIds[j];
            }
            if (message.revieweeIds && message.revieweeIds.length) {
                object.revieweeIds = [];
                for (let j = 0; j < message.revieweeIds.length; ++j)
                    object.revieweeIds[j] = message.revieweeIds[j];
            }
            if (message.applicableReviewFrequencies && message.applicableReviewFrequencies.length) {
                object.applicableReviewFrequencies = [];
                for (let j = 0; j < message.applicableReviewFrequencies.length; ++j)
                    object.applicableReviewFrequencies[j] = message.applicableReviewFrequencies[j];
            }
            if (message.parentIds && message.parentIds.length) {
                object.parentIds = [];
                for (let j = 0; j < message.parentIds.length; ++j)
                    object.parentIds[j] = message.parentIds[j];
            }
            if (message.reviewerNames && message.reviewerNames.length) {
                object.reviewerNames = [];
                for (let j = 0; j < message.reviewerNames.length; ++j)
                    object.reviewerNames[j] = message.reviewerNames[j];
            }
            if (message.revieweeNames && message.revieweeNames.length) {
                object.revieweeNames = [];
                for (let j = 0; j < message.revieweeNames.length; ++j)
                    object.revieweeNames[j] = message.revieweeNames[j];
            }
            if (message.reviewEntityTypeName != null && message.hasOwnProperty("reviewEntityTypeName"))
                object.reviewEntityTypeName = message.reviewEntityTypeName;
            if (message.attributes && message.attributes.length) {
                object.attributes = [];
                for (let j = 0; j < message.attributes.length; ++j)
                    object.attributes[j] = $root.review.ReviewEntityAttribute.toObject(message.attributes[j], options);
            }
            if (message.createdBy != null && message.hasOwnProperty("createdBy"))
                object.createdBy = message.createdBy;
            if (message.updatedBy != null && message.hasOwnProperty("updatedBy"))
                object.updatedBy = message.updatedBy;
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                object.createdAt = message.createdAt;
            if (message.updatedAt != null && message.hasOwnProperty("updatedAt"))
                object.updatedAt = message.updatedAt;
            return object;
        };

        /**
         * Converts this ReviewEntity to JSON.
         * @function toJSON
         * @memberof review.ReviewEntity
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ReviewEntity.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ReviewEntity
         * @function getTypeUrl
         * @memberof review.ReviewEntity
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ReviewEntity.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/review.ReviewEntity";
        };

        return ReviewEntity;
    })();

    review.ReviewEntityList = (function() {

        /**
         * Properties of a ReviewEntityList.
         * @memberof review
         * @interface IReviewEntityList
         * @property {Array.<review.IReviewEntity>|null} [entities] ReviewEntityList entities
         */

        /**
         * Constructs a new ReviewEntityList.
         * @memberof review
         * @classdesc Represents a ReviewEntityList.
         * @implements IReviewEntityList
         * @constructor
         * @param {review.IReviewEntityList=} [properties] Properties to set
         */
        function ReviewEntityList(properties) {
            this.entities = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ReviewEntityList entities.
         * @member {Array.<review.IReviewEntity>} entities
         * @memberof review.ReviewEntityList
         * @instance
         */
        ReviewEntityList.prototype.entities = $util.emptyArray;

        /**
         * Creates a new ReviewEntityList instance using the specified properties.
         * @function create
         * @memberof review.ReviewEntityList
         * @static
         * @param {review.IReviewEntityList=} [properties] Properties to set
         * @returns {review.ReviewEntityList} ReviewEntityList instance
         */
        ReviewEntityList.create = function create(properties) {
            return new ReviewEntityList(properties);
        };

        /**
         * Encodes the specified ReviewEntityList message. Does not implicitly {@link review.ReviewEntityList.verify|verify} messages.
         * @function encode
         * @memberof review.ReviewEntityList
         * @static
         * @param {review.IReviewEntityList} message ReviewEntityList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReviewEntityList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.entities != null && message.entities.length)
                for (let i = 0; i < message.entities.length; ++i)
                    $root.review.ReviewEntity.encode(message.entities[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ReviewEntityList message, length delimited. Does not implicitly {@link review.ReviewEntityList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof review.ReviewEntityList
         * @static
         * @param {review.IReviewEntityList} message ReviewEntityList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReviewEntityList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ReviewEntityList message from the specified reader or buffer.
         * @function decode
         * @memberof review.ReviewEntityList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {review.ReviewEntityList} ReviewEntityList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReviewEntityList.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.review.ReviewEntityList();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        if (!(message.entities && message.entities.length))
                            message.entities = [];
                        message.entities.push($root.review.ReviewEntity.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ReviewEntityList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof review.ReviewEntityList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {review.ReviewEntityList} ReviewEntityList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReviewEntityList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ReviewEntityList message.
         * @function verify
         * @memberof review.ReviewEntityList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ReviewEntityList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.entities != null && message.hasOwnProperty("entities")) {
                if (!Array.isArray(message.entities))
                    return "entities: array expected";
                for (let i = 0; i < message.entities.length; ++i) {
                    let error = $root.review.ReviewEntity.verify(message.entities[i]);
                    if (error)
                        return "entities." + error;
                }
            }
            return null;
        };

        /**
         * Creates a ReviewEntityList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof review.ReviewEntityList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {review.ReviewEntityList} ReviewEntityList
         */
        ReviewEntityList.fromObject = function fromObject(object) {
            if (object instanceof $root.review.ReviewEntityList)
                return object;
            let message = new $root.review.ReviewEntityList();
            if (object.entities) {
                if (!Array.isArray(object.entities))
                    throw TypeError(".review.ReviewEntityList.entities: array expected");
                message.entities = [];
                for (let i = 0; i < object.entities.length; ++i) {
                    if (typeof object.entities[i] !== "object")
                        throw TypeError(".review.ReviewEntityList.entities: object expected");
                    message.entities[i] = $root.review.ReviewEntity.fromObject(object.entities[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ReviewEntityList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof review.ReviewEntityList
         * @static
         * @param {review.ReviewEntityList} message ReviewEntityList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ReviewEntityList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.entities = [];
            if (message.entities && message.entities.length) {
                object.entities = [];
                for (let j = 0; j < message.entities.length; ++j)
                    object.entities[j] = $root.review.ReviewEntity.toObject(message.entities[j], options);
            }
            return object;
        };

        /**
         * Converts this ReviewEntityList to JSON.
         * @function toJSON
         * @memberof review.ReviewEntityList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ReviewEntityList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ReviewEntityList
         * @function getTypeUrl
         * @memberof review.ReviewEntityList
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ReviewEntityList.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/review.ReviewEntityList";
        };

        return ReviewEntityList;
    })();

    review.ReviewQuestion = (function() {

        /**
         * Properties of a ReviewQuestion.
         * @memberof review
         * @interface IReviewQuestion
         * @property {number|null} [id] ReviewQuestion id
         * @property {string|null} [reviewQuestionText] ReviewQuestion reviewQuestionText
         * @property {string|null} [description] ReviewQuestion description
         * @property {string|null} [reviewDimension] ReviewQuestion reviewDimension
         * @property {string|null} [reviewFrequency] ReviewQuestion reviewFrequency
         * @property {string|null} [reviewEntityType] ReviewQuestion reviewEntityType
         * @property {string|null} [answerType] ReviewQuestion answerType
         * @property {Array.<string>|null} [answerOptions] ReviewQuestion answerOptions
         * @property {string|null} [reviewQuestionType] ReviewQuestion reviewQuestionType
         * @property {string|null} [actionRequired] ReviewQuestion actionRequired
         * @property {string|null} [idealValue] ReviewQuestion idealValue
         * @property {string|null} [defaultValue] ReviewQuestion defaultValue
         */

        /**
         * Constructs a new ReviewQuestion.
         * @memberof review
         * @classdesc Represents a ReviewQuestion.
         * @implements IReviewQuestion
         * @constructor
         * @param {review.IReviewQuestion=} [properties] Properties to set
         */
        function ReviewQuestion(properties) {
            this.answerOptions = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ReviewQuestion id.
         * @member {number} id
         * @memberof review.ReviewQuestion
         * @instance
         */
        ReviewQuestion.prototype.id = 0;

        /**
         * ReviewQuestion reviewQuestionText.
         * @member {string} reviewQuestionText
         * @memberof review.ReviewQuestion
         * @instance
         */
        ReviewQuestion.prototype.reviewQuestionText = "";

        /**
         * ReviewQuestion description.
         * @member {string} description
         * @memberof review.ReviewQuestion
         * @instance
         */
        ReviewQuestion.prototype.description = "";

        /**
         * ReviewQuestion reviewDimension.
         * @member {string} reviewDimension
         * @memberof review.ReviewQuestion
         * @instance
         */
        ReviewQuestion.prototype.reviewDimension = "";

        /**
         * ReviewQuestion reviewFrequency.
         * @member {string} reviewFrequency
         * @memberof review.ReviewQuestion
         * @instance
         */
        ReviewQuestion.prototype.reviewFrequency = "";

        /**
         * ReviewQuestion reviewEntityType.
         * @member {string} reviewEntityType
         * @memberof review.ReviewQuestion
         * @instance
         */
        ReviewQuestion.prototype.reviewEntityType = "";

        /**
         * ReviewQuestion answerType.
         * @member {string} answerType
         * @memberof review.ReviewQuestion
         * @instance
         */
        ReviewQuestion.prototype.answerType = "";

        /**
         * ReviewQuestion answerOptions.
         * @member {Array.<string>} answerOptions
         * @memberof review.ReviewQuestion
         * @instance
         */
        ReviewQuestion.prototype.answerOptions = $util.emptyArray;

        /**
         * ReviewQuestion reviewQuestionType.
         * @member {string} reviewQuestionType
         * @memberof review.ReviewQuestion
         * @instance
         */
        ReviewQuestion.prototype.reviewQuestionType = "";

        /**
         * ReviewQuestion actionRequired.
         * @member {string} actionRequired
         * @memberof review.ReviewQuestion
         * @instance
         */
        ReviewQuestion.prototype.actionRequired = "";

        /**
         * ReviewQuestion idealValue.
         * @member {string} idealValue
         * @memberof review.ReviewQuestion
         * @instance
         */
        ReviewQuestion.prototype.idealValue = "";

        /**
         * ReviewQuestion defaultValue.
         * @member {string} defaultValue
         * @memberof review.ReviewQuestion
         * @instance
         */
        ReviewQuestion.prototype.defaultValue = "";

        /**
         * Creates a new ReviewQuestion instance using the specified properties.
         * @function create
         * @memberof review.ReviewQuestion
         * @static
         * @param {review.IReviewQuestion=} [properties] Properties to set
         * @returns {review.ReviewQuestion} ReviewQuestion instance
         */
        ReviewQuestion.create = function create(properties) {
            return new ReviewQuestion(properties);
        };

        /**
         * Encodes the specified ReviewQuestion message. Does not implicitly {@link review.ReviewQuestion.verify|verify} messages.
         * @function encode
         * @memberof review.ReviewQuestion
         * @static
         * @param {review.IReviewQuestion} message ReviewQuestion message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReviewQuestion.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.id);
            if (message.reviewQuestionText != null && Object.hasOwnProperty.call(message, "reviewQuestionText"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.reviewQuestionText);
            if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.description);
            if (message.reviewDimension != null && Object.hasOwnProperty.call(message, "reviewDimension"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.reviewDimension);
            if (message.reviewFrequency != null && Object.hasOwnProperty.call(message, "reviewFrequency"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.reviewFrequency);
            if (message.reviewEntityType != null && Object.hasOwnProperty.call(message, "reviewEntityType"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.reviewEntityType);
            if (message.answerType != null && Object.hasOwnProperty.call(message, "answerType"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.answerType);
            if (message.answerOptions != null && message.answerOptions.length)
                for (let i = 0; i < message.answerOptions.length; ++i)
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.answerOptions[i]);
            if (message.reviewQuestionType != null && Object.hasOwnProperty.call(message, "reviewQuestionType"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.reviewQuestionType);
            if (message.actionRequired != null && Object.hasOwnProperty.call(message, "actionRequired"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.actionRequired);
            if (message.idealValue != null && Object.hasOwnProperty.call(message, "idealValue"))
                writer.uint32(/* id 11, wireType 2 =*/90).string(message.idealValue);
            if (message.defaultValue != null && Object.hasOwnProperty.call(message, "defaultValue"))
                writer.uint32(/* id 12, wireType 2 =*/98).string(message.defaultValue);
            return writer;
        };

        /**
         * Encodes the specified ReviewQuestion message, length delimited. Does not implicitly {@link review.ReviewQuestion.verify|verify} messages.
         * @function encodeDelimited
         * @memberof review.ReviewQuestion
         * @static
         * @param {review.IReviewQuestion} message ReviewQuestion message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReviewQuestion.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ReviewQuestion message from the specified reader or buffer.
         * @function decode
         * @memberof review.ReviewQuestion
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {review.ReviewQuestion} ReviewQuestion
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReviewQuestion.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.review.ReviewQuestion();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.id = reader.int32();
                        break;
                    }
                case 2: {
                        message.reviewQuestionText = reader.string();
                        break;
                    }
                case 3: {
                        message.description = reader.string();
                        break;
                    }
                case 4: {
                        message.reviewDimension = reader.string();
                        break;
                    }
                case 5: {
                        message.reviewFrequency = reader.string();
                        break;
                    }
                case 6: {
                        message.reviewEntityType = reader.string();
                        break;
                    }
                case 7: {
                        message.answerType = reader.string();
                        break;
                    }
                case 8: {
                        if (!(message.answerOptions && message.answerOptions.length))
                            message.answerOptions = [];
                        message.answerOptions.push(reader.string());
                        break;
                    }
                case 9: {
                        message.reviewQuestionType = reader.string();
                        break;
                    }
                case 10: {
                        message.actionRequired = reader.string();
                        break;
                    }
                case 11: {
                        message.idealValue = reader.string();
                        break;
                    }
                case 12: {
                        message.defaultValue = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ReviewQuestion message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof review.ReviewQuestion
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {review.ReviewQuestion} ReviewQuestion
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReviewQuestion.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ReviewQuestion message.
         * @function verify
         * @memberof review.ReviewQuestion
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ReviewQuestion.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isInteger(message.id))
                    return "id: integer expected";
            if (message.reviewQuestionText != null && message.hasOwnProperty("reviewQuestionText"))
                if (!$util.isString(message.reviewQuestionText))
                    return "reviewQuestionText: string expected";
            if (message.description != null && message.hasOwnProperty("description"))
                if (!$util.isString(message.description))
                    return "description: string expected";
            if (message.reviewDimension != null && message.hasOwnProperty("reviewDimension"))
                if (!$util.isString(message.reviewDimension))
                    return "reviewDimension: string expected";
            if (message.reviewFrequency != null && message.hasOwnProperty("reviewFrequency"))
                if (!$util.isString(message.reviewFrequency))
                    return "reviewFrequency: string expected";
            if (message.reviewEntityType != null && message.hasOwnProperty("reviewEntityType"))
                if (!$util.isString(message.reviewEntityType))
                    return "reviewEntityType: string expected";
            if (message.answerType != null && message.hasOwnProperty("answerType"))
                if (!$util.isString(message.answerType))
                    return "answerType: string expected";
            if (message.answerOptions != null && message.hasOwnProperty("answerOptions")) {
                if (!Array.isArray(message.answerOptions))
                    return "answerOptions: array expected";
                for (let i = 0; i < message.answerOptions.length; ++i)
                    if (!$util.isString(message.answerOptions[i]))
                        return "answerOptions: string[] expected";
            }
            if (message.reviewQuestionType != null && message.hasOwnProperty("reviewQuestionType"))
                if (!$util.isString(message.reviewQuestionType))
                    return "reviewQuestionType: string expected";
            if (message.actionRequired != null && message.hasOwnProperty("actionRequired"))
                if (!$util.isString(message.actionRequired))
                    return "actionRequired: string expected";
            if (message.idealValue != null && message.hasOwnProperty("idealValue"))
                if (!$util.isString(message.idealValue))
                    return "idealValue: string expected";
            if (message.defaultValue != null && message.hasOwnProperty("defaultValue"))
                if (!$util.isString(message.defaultValue))
                    return "defaultValue: string expected";
            return null;
        };

        /**
         * Creates a ReviewQuestion message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof review.ReviewQuestion
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {review.ReviewQuestion} ReviewQuestion
         */
        ReviewQuestion.fromObject = function fromObject(object) {
            if (object instanceof $root.review.ReviewQuestion)
                return object;
            let message = new $root.review.ReviewQuestion();
            if (object.id != null)
                message.id = object.id | 0;
            if (object.reviewQuestionText != null)
                message.reviewQuestionText = String(object.reviewQuestionText);
            if (object.description != null)
                message.description = String(object.description);
            if (object.reviewDimension != null)
                message.reviewDimension = String(object.reviewDimension);
            if (object.reviewFrequency != null)
                message.reviewFrequency = String(object.reviewFrequency);
            if (object.reviewEntityType != null)
                message.reviewEntityType = String(object.reviewEntityType);
            if (object.answerType != null)
                message.answerType = String(object.answerType);
            if (object.answerOptions) {
                if (!Array.isArray(object.answerOptions))
                    throw TypeError(".review.ReviewQuestion.answerOptions: array expected");
                message.answerOptions = [];
                for (let i = 0; i < object.answerOptions.length; ++i)
                    message.answerOptions[i] = String(object.answerOptions[i]);
            }
            if (object.reviewQuestionType != null)
                message.reviewQuestionType = String(object.reviewQuestionType);
            if (object.actionRequired != null)
                message.actionRequired = String(object.actionRequired);
            if (object.idealValue != null)
                message.idealValue = String(object.idealValue);
            if (object.defaultValue != null)
                message.defaultValue = String(object.defaultValue);
            return message;
        };

        /**
         * Creates a plain object from a ReviewQuestion message. Also converts values to other types if specified.
         * @function toObject
         * @memberof review.ReviewQuestion
         * @static
         * @param {review.ReviewQuestion} message ReviewQuestion
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ReviewQuestion.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.answerOptions = [];
            if (options.defaults) {
                object.id = 0;
                object.reviewQuestionText = "";
                object.description = "";
                object.reviewDimension = "";
                object.reviewFrequency = "";
                object.reviewEntityType = "";
                object.answerType = "";
                object.reviewQuestionType = "";
                object.actionRequired = "";
                object.idealValue = "";
                object.defaultValue = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.reviewQuestionText != null && message.hasOwnProperty("reviewQuestionText"))
                object.reviewQuestionText = message.reviewQuestionText;
            if (message.description != null && message.hasOwnProperty("description"))
                object.description = message.description;
            if (message.reviewDimension != null && message.hasOwnProperty("reviewDimension"))
                object.reviewDimension = message.reviewDimension;
            if (message.reviewFrequency != null && message.hasOwnProperty("reviewFrequency"))
                object.reviewFrequency = message.reviewFrequency;
            if (message.reviewEntityType != null && message.hasOwnProperty("reviewEntityType"))
                object.reviewEntityType = message.reviewEntityType;
            if (message.answerType != null && message.hasOwnProperty("answerType"))
                object.answerType = message.answerType;
            if (message.answerOptions && message.answerOptions.length) {
                object.answerOptions = [];
                for (let j = 0; j < message.answerOptions.length; ++j)
                    object.answerOptions[j] = message.answerOptions[j];
            }
            if (message.reviewQuestionType != null && message.hasOwnProperty("reviewQuestionType"))
                object.reviewQuestionType = message.reviewQuestionType;
            if (message.actionRequired != null && message.hasOwnProperty("actionRequired"))
                object.actionRequired = message.actionRequired;
            if (message.idealValue != null && message.hasOwnProperty("idealValue"))
                object.idealValue = message.idealValue;
            if (message.defaultValue != null && message.hasOwnProperty("defaultValue"))
                object.defaultValue = message.defaultValue;
            return object;
        };

        /**
         * Converts this ReviewQuestion to JSON.
         * @function toJSON
         * @memberof review.ReviewQuestion
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ReviewQuestion.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ReviewQuestion
         * @function getTypeUrl
         * @memberof review.ReviewQuestion
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ReviewQuestion.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/review.ReviewQuestion";
        };

        return ReviewQuestion;
    })();

    review.ReviewQuestionList = (function() {

        /**
         * Properties of a ReviewQuestionList.
         * @memberof review
         * @interface IReviewQuestionList
         * @property {Array.<review.IReviewQuestion>|null} [questions] ReviewQuestionList questions
         */

        /**
         * Constructs a new ReviewQuestionList.
         * @memberof review
         * @classdesc Represents a ReviewQuestionList.
         * @implements IReviewQuestionList
         * @constructor
         * @param {review.IReviewQuestionList=} [properties] Properties to set
         */
        function ReviewQuestionList(properties) {
            this.questions = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ReviewQuestionList questions.
         * @member {Array.<review.IReviewQuestion>} questions
         * @memberof review.ReviewQuestionList
         * @instance
         */
        ReviewQuestionList.prototype.questions = $util.emptyArray;

        /**
         * Creates a new ReviewQuestionList instance using the specified properties.
         * @function create
         * @memberof review.ReviewQuestionList
         * @static
         * @param {review.IReviewQuestionList=} [properties] Properties to set
         * @returns {review.ReviewQuestionList} ReviewQuestionList instance
         */
        ReviewQuestionList.create = function create(properties) {
            return new ReviewQuestionList(properties);
        };

        /**
         * Encodes the specified ReviewQuestionList message. Does not implicitly {@link review.ReviewQuestionList.verify|verify} messages.
         * @function encode
         * @memberof review.ReviewQuestionList
         * @static
         * @param {review.IReviewQuestionList} message ReviewQuestionList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReviewQuestionList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.questions != null && message.questions.length)
                for (let i = 0; i < message.questions.length; ++i)
                    $root.review.ReviewQuestion.encode(message.questions[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ReviewQuestionList message, length delimited. Does not implicitly {@link review.ReviewQuestionList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof review.ReviewQuestionList
         * @static
         * @param {review.IReviewQuestionList} message ReviewQuestionList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReviewQuestionList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ReviewQuestionList message from the specified reader or buffer.
         * @function decode
         * @memberof review.ReviewQuestionList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {review.ReviewQuestionList} ReviewQuestionList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReviewQuestionList.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.review.ReviewQuestionList();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        if (!(message.questions && message.questions.length))
                            message.questions = [];
                        message.questions.push($root.review.ReviewQuestion.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ReviewQuestionList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof review.ReviewQuestionList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {review.ReviewQuestionList} ReviewQuestionList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReviewQuestionList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ReviewQuestionList message.
         * @function verify
         * @memberof review.ReviewQuestionList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ReviewQuestionList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.questions != null && message.hasOwnProperty("questions")) {
                if (!Array.isArray(message.questions))
                    return "questions: array expected";
                for (let i = 0; i < message.questions.length; ++i) {
                    let error = $root.review.ReviewQuestion.verify(message.questions[i]);
                    if (error)
                        return "questions." + error;
                }
            }
            return null;
        };

        /**
         * Creates a ReviewQuestionList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof review.ReviewQuestionList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {review.ReviewQuestionList} ReviewQuestionList
         */
        ReviewQuestionList.fromObject = function fromObject(object) {
            if (object instanceof $root.review.ReviewQuestionList)
                return object;
            let message = new $root.review.ReviewQuestionList();
            if (object.questions) {
                if (!Array.isArray(object.questions))
                    throw TypeError(".review.ReviewQuestionList.questions: array expected");
                message.questions = [];
                for (let i = 0; i < object.questions.length; ++i) {
                    if (typeof object.questions[i] !== "object")
                        throw TypeError(".review.ReviewQuestionList.questions: object expected");
                    message.questions[i] = $root.review.ReviewQuestion.fromObject(object.questions[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ReviewQuestionList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof review.ReviewQuestionList
         * @static
         * @param {review.ReviewQuestionList} message ReviewQuestionList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ReviewQuestionList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.questions = [];
            if (message.questions && message.questions.length) {
                object.questions = [];
                for (let j = 0; j < message.questions.length; ++j)
                    object.questions[j] = $root.review.ReviewQuestion.toObject(message.questions[j], options);
            }
            return object;
        };

        /**
         * Converts this ReviewQuestionList to JSON.
         * @function toJSON
         * @memberof review.ReviewQuestionList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ReviewQuestionList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ReviewQuestionList
         * @function getTypeUrl
         * @memberof review.ReviewQuestionList
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ReviewQuestionList.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/review.ReviewQuestionList";
        };

        return ReviewQuestionList;
    })();

    return review;
})();

export { $root as default };
